module.exports = __webpack_public_path__ + "static/img/wdys1-4.33b7ef5.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdys1-4.png
// module id = 891
// module chunks = 0